import { Component } from 'sane-ui'
import Flickity from 'flickity'
import arrowShape from '../config/flickiyArrowShape.json'

const Waypoint = window.Waypoint

class MediaGallery extends Component {
  constructor ($el, args) {
    super($el, args)

    const data = $el.data()
    const $slider = this.$el.find('.media-gallery__slider')
    let currentIndex = 0

    this.slider = new Flickity(
      $slider.get(0),
      {
        // lazyLoad: 2,
        autoPlay: data.autoPlay * 1000,
        pauseAutoPlayOnHover: true,
        wrapAround: true,
        arrowShape,
        on: {
          settle: (index) => {
            const $prevItem = this.$el.find('.media-item').eq(currentIndex)
            const $iframe = $prevItem.find('iframe')
            const $video = $prevItem.find('video')

            if ($iframe.length > 0) {
              $iframe.attr('src', $iframe.attr('src'))
            } else if ($video.length > 0) {
              $video.get(0).pause()
            }

            currentIndex = index
          },
        },
      }
    )

    this.slider.pausePlayer()
    const slider = this.slider

    new Waypoint({ // eslint-disable-line no-new
      element: this.$el.get(0),
      handler: function () {
        slider.unpausePlayer()
        this.disable()
      },
      offset: '90%',
    })
  }
}

export default MediaGallery



// WEBPACK FOOTER //
// ./scripts/components/MediaGallery.js